// utils/gtag.js

export const loadGoogleAnalytics = (trackingId = 'G-94NRJ1R0FQ') => {
  if (!trackingId) {
    console.error('No tracking ID provided.');
    return;
  }

  // Create the GA script tag and insert it into the document head
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  document.head.appendChild(script);

  // Initialize the dataLayer and define the gtag function
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;

  // Configure GA with the current tracking ID and add your stream ID
  gtag('js', new Date());
  gtag('config', trackingId, { 'stream_id': '10387924816' });
};

export default loadGoogleAnalytics;
